/* MapLibre's worker URL, set when this module is first imported. The setting is
 * global to the library, so one import before a map is built covers every map
 * in either entry.
 *
 * What this deliberately is not: a basemap. The web app's style, archive and
 * attribution are routes/map/basemap.ts.
 */
import * as maplibregl from "maplibre-gl";

/* MapLibre locates its worker via import.meta.url at runtime, which neither
 * Vite's dev pre-bundler nor its Rollup production build resolve correctly
 * for this package - the worker request 404s in dev, and in a production
 * build the worker chunk either isn't emitted or (via a `?url` asset copy)
 * loses the sibling maplibre-gl-shared.mjs chunk it imports internally, so a
 * GeoJSON source never tiles and nothing renders, silently, either way.
 *
 * public/vendor holds a vendored copy of both files, verbatim from
 * node_modules/maplibre-gl/dist - Vite serves public/ unprocessed in dev and
 * copies it as-is to the build output, so the worker's own relative import
 * of its shared chunk keeps resolving in both. setWorkerUrl is MapLibre's
 * own documented escape hatch for pointing it at a URL rather than letting
 * it self-locate. Re-copy both files here if maplibre-gl is upgraded.
 */
maplibregl.setWorkerUrl("/vendor/maplibre-gl-worker.mjs");

export { maplibregl };
